import { render, staticRenderFns } from "./KranjiLandingPage.vue?vue&type=template&id=f5aa0eba"
import script from "./KranjiLandingPage.vue?vue&type=script&lang=js"
export * from "./KranjiLandingPage.vue?vue&type=script&lang=js"
import style0 from "./KranjiLandingPage.vue?vue&type=style&index=0&id=f5aa0eba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports